import { Rows, TableNode } from '../index';

export function $createTableNode(rows: Rows): TableNode {
  return new TableNode(rows);
}
